module.exports = __webpack_public_path__ + "img/diploma1.35b6e816.jpg";